// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import * as React from "react";

type Props = WidgetProps & HasProduct;

export interface ProductLongDescriptionStyles {
    labelText?: TypographyProps;
}

export const productLongDescriptionStyles: ProductLongDescriptionStyles = {};

const styles = productLongDescriptionStyles;

const ProductLongDescription: React.FC<Props> = ({ product }) => {
    if (!product.properties?.productLongDescription) {
        return null;
    }

    return <Typography {...styles.labelText}>{product.properties.productLongDescription}</Typography>;
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductLongDescription),
    definition: {
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
